<template>
<div>
  <v-snackbar v-if="error"
      :timeout="-1"
      :value="true"
      absolute
      bottom
      color="red"
      outlined
      centered
    >
      {{this.error}}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="error=null"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  <forecast-table
    :userdata="tableData"
    :loading="loading"
    v-on:inputChange="updateYear"
  ></forecast-table>
</div>
</template>
<script>
import ForecastTable from "../ForecastTable";
export default {
  components: { ForecastTable },
  data() {
    return {
      error:null,
      tableData: undefined,
      loading:true,
      year: 2021,
    };
  },
  created() {
    axios
      .get(`/forecast/forecasting`, { params: { year: this.year } })
      .then((res) => {
        this.tableData = res.data;
      })
      .catch((error) => (this.error = error.response.data.message));
  },
  methods: {
    updateYear(e) {
      this.year = e;
      this.tableData = undefined;
      this.loading = false;
      axios
        .get(`/forecast/forecasting`, { params: { year: this.year } })
        .then((res) => {
          this.tableData = res.data;
        })
        .catch((error) => (this.error = error.response.data.errors));
    },
  },
};
</script>
<style >
</style>